import {useQuery, useQueryClient} from '@tanstack/react-query';
import {apiService} from '../services/api';
import {TermsState} from '../types';

const KEY = ['terms'];

/**
 * The company's consent to the terms and conditions. Asked for only on behalf
 * of the one who can give it - the company's client admin; a failed read
 * holds nobody.
 */
export const useTerms = (enabled: boolean) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: KEY,
        queryFn: async (): Promise<TermsState | null> => {
            const response = await apiService.getTerms();
            return response.success ? response.data : null;
        },
        enabled,
    });

    return {
        terms: enabled ? query.data ?? null : null,
        setTerms: (terms: TermsState) => queryClient.setQueryData(KEY, terms),
    };
};
